import { getQueryStringParams } from './helpers/getQueryStringParams';

/**
 * Debug/QA escape hatch: reads the `overridePlayerExperiment` page
 * query-parameter and returns an `{ id: variant }` map that can be merged
 * into `experimentMap` (override wins) to force any player experiment to a
 * given variant, in any environment.
 *
 * Format: comma-separated `id:variant` pairs, e.g.
 * `?overridePlayerExperiment=vmap:enabled,tpaas:enabled`.
 *
 * Malformed pairs (missing id, missing variant, or empty segments) are
 * silently ignored. Ids and variants are trimmed of surrounding whitespace.
 *
 * This is intentionally isolated: removing this file and its single call
 * site in `./index.ts` fully removes the feature.
 */
function getExperimentOverrides(): Record<string, string> {
  const { overridePlayerExperiment } = getQueryStringParams();

  const overrides: Record<string, string> = {};

  if (!overridePlayerExperiment) {
    return overrides;
  }

  overridePlayerExperiment.split(',').forEach((pair) => {
    const [rawId, rawVariant] = pair.split(':');
    const id = rawId?.trim();
    const variant = rawVariant?.trim();

    if (!id || !variant) {
      return;
    }

    overrides[id] = variant;
  });

  return overrides;
}

export { getExperimentOverrides };
